var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup42(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.8333C18 15.2754 17.8209 15.6993 17.5021 16.0118C17.1833 16.3244 16.7509 16.5 16.3 16.5H2.7C2.24913 16.5 1.81673 16.3244 1.49792 16.0118C1.17911 15.6993 1 15.2754 1 14.8333V3.16667C1 2.72464 1.17911 2.30072 1.49792 1.98816C1.81673 1.67559 2.24913 1.5 2.7 1.5H6.95L8.65 4H16.3C16.7509 4 17.1833 4.17559 17.5021 4.48816C17.8209 4.80072 18 5.22464 18 5.66667V14.8333Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup42);
export default __webpack_public_path__ + "static/media/Group42.d24ee35840fa4c545be040d8bc3fd73e.svg";
export { ForwardRef as ReactComponent };